import { render, staticRenderFns } from "./SavedSearchesModal.vue?vue&type=template&id=64275dc6&scoped=true"
import script from "./SavedSearchesModal.vue?vue&type=script&lang=js"
export * from "./SavedSearchesModal.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchesModal.vue?vue&type=style&index=0&id=64275dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64275dc6",
  null
  
)

export default component.exports